
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"512pt","viewBox":"0 -15 512 512","width":"512pt","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M482 151.32h-62v-90H286.305L221.793 0l-61.988 61.32H60c-33.082 0-60 26.914-60 59.996V406.32c0 41.356 33.645 75 75 75h407v-90h30v-150h-30zm-92-60v60h-9.008l-63.125-60zm-52.555 60H196.453l69.242-68.199zM222.207 41.785l21.734 20.656-90.242 88.88h-42.215zM60 91.32h69.48L69.941 150.22C48.867 147.695 30 140.176 30 121.32c0-16.543 13.457-30 30-30zm392 360H75c-24.813 0-45-20.187-45-45V169.473c13.36 7.047 32.531 11.847 60 11.847h362v60H300v150h152zm30-90H330v-90h152zm0 0"}}),_c('path',{attrs:{"d":"M375 301.32h30v30h-30zm0 0"}})])
          )
        }
      }
    